import { Component, OnInit, ViewChild, NgZone, OnDestroy, Input, SimpleChanges, HostListener } from '@angular/core';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { ApiCotacoesService } from 'src/app/services/api-cotacoes.service';
import { PlatformService } from 'src/app/services/platform.service';
import { CotacoesPDocs } from 'src/app/models/cotacoes.model';
import { MenusService } from '../../services/menus.service';
import { ListaScrollingComponent } from 'src/app/components/lista-scrolling/lista-scrolling.component';
import { Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { GAnalyticsService } from 'src/app/services/g-analytics.service';
import { Mask } from 'src/app/utils/masks';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { FormControl } from '@angular/forms';
import { BuscaService } from 'src/app/services/busca.service';
@Component({
	selector: 'app-cotacoes',
	templateUrl: './cotacoes.component.html',
	styleUrls: ['./cotacoes.component.scss']
})
export class CotacoesComponent implements OnInit, OnDestroy {	
	subscriptions = new Subscription();
	fabButtons = [
		{
		  icone: 'car-hatchback',
		  titulo: 'Cotar Automóvel',
		  url: '/cotacao/auto/formulario',
		  open: async (urlPage) => {
			this.route.navigate([urlPage]).then(() => {
			  //this.loadingPage = false;
			})
			this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_auto', 'Iniciando nova cotação Auto');
		  },
		  calcular: true,
		},
		// {
		//   icone: 'motorbike',
		//   titulo: 'Cotar Moto',
		//   url: '/cotacao-form/tipo/moto',
		//   open: async (urlPage) => {
	
		//   },
		//   calcular: true
		// },
		{
		  icone: 'home',
		  titulo: 'Cotar Residencial',
		  url: '/cotacao/residencial/formulario',
		  open: async (urlPage) => {
			// this.loadingPage = true;
			this.route.navigate([urlPage]).then(() => {
			  //this.loadingPage = false;
			})
			// .catch(()=> {this.loadingPage = false;});
			this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_residencial', 'Iniciando nova cotação Residencial');
		  },
		  calcular: true
		},
		{
		  icone: 'factory',
		  titulo: 'Cotar Empresarial',
		  url: '/cotacao/empresarial/formulario',
		  open: async (urlPage) => {
			this.route.navigate([urlPage]).then(() => {
			})
			this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_empresarial', 'Iniciando nova cotação Empresarial');
		  },
		  calcular: true
		},
		{
		  icone: 'cards-heart',
		  titulo: 'Cotar Vida',
		  url: '/cotacao/vida/formulario',
		  open: async (urlPage) => {
			// this.loadingPage = true;
			this.route.navigate([urlPage]).then(() => {
			  //this.loadingPage = false;
			})
			// .catch(()=> {this.loadingPage = false;});
			this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_vida', 'Iniciando nova cotação Vida');
		  },
		  calcular: true
		},
		{
			icone: 'vida-global',
			titulo: 'Cotar Vida Global',
			url: '/cotacao/vida_global/formulario',
			open: async (urlPage) => {
			  // this.loadingPage = true;
			  this.route.navigate([urlPage]).then(() => {
				//this.loadingPage = false;
			  })
			  // .catch(()=> {this.loadingPage = false;});
			  this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_vida_global', 'Iniciando nova cotação Vida Global');
			},
			calcular: true
		},
		{
			icone: 'account-injury',
			titulo: 'Cotar Acidentes Pessoais',
			url: '/cotacao/acidentes_pessoais/formulario',
			open: async (urlPage) => {
			  // this.loadingPage = true;
			  this.route.navigate([urlPage]).then(() => {
				//this.loadingPage = false;
			  })
			  // .catch(()=> {this.loadingPage = false;});
			  this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_acidentes_pessoais', 'Iniciando nova cotação Acidentes Pessoais');
			},
			calcular: true
		},
		{
			icone: 'bag-suitcase',
			titulo: 'Cotar viagem',
			url: '/cotacao/viagem/formulario',
			open: async (urlPage) => {
				// this.loadingPage = true;
				this.route.navigate([urlPage]).then(() => {
				  //this.loadingPage = false;
				})
				// .catch(()=> {this.loadingPage = false;});
				this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_viagem', 'Iniciando nova cotação Viagem');
			  },
			calcular: true
		},
		{
			icone: 'domain',
			titulo: 'Cotar Condomínio',
			url: '/cotacao/condominio/formulario',
			open: async (urlPage) => {
			  // this.loadingPage = true;
			  this.route.navigate([urlPage]).then(() => {
				//this.loadingPage = false;
			  })
			  // .catch(()=> {this.loadingPage = false;});
			  this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_condominio', 'Iniciando nova cotação Condomínio');
			},
			calcular: true
		  }
		// {
		//     icone: 'mdi mdi-truck',
		//     titulo: 'Cotar Caminhão',
		//     url: '/cotacao-form/tipo/caminhao',
		//     calcular: true
		// },
	];

	@Input('isComponent') isComponent: boolean = false;
	@Input('dataBuscaGeral') dataBuscaGeral: any;
	listaScrolling;
	@ViewChild('listaScrolling') set listaScrollingComponent(listaScrollingComponent: ListaScrollingComponent) {
		this.listaScrolling = listaScrollingComponent;
		if (this.listaScrolling) {
			this.listaScrolling.pullReloadingAnimation = 'hide';
		}
	}
	lista = [];
	filtroBusca: string;
	retornoFiltro;
	itensFiltrados: String = 'todas';
	ramo:any = '';
	usuarioFiltrado;
	listaStatusNegocioFiltrados = [];
	menuOpen;
	loading: boolean = false
	masks = Mask;
	intervalUpdateList;
	copyList = [];
	novasCotacoes;
	atualizarLista: boolean = false;
	timeInterval = 1000 * 60;
	counInterval = 0;
	ramos = IntegracaoConstants.headerRamosCotacao;
	ramoSelecionado = new FormControl(0);
	periodoOptions = IntegracaoConstants.valoresFiltroPeriodo;
	periodo = new FormControl(9999999);
	arraySkeleton = [];
	rows = 18;
	columns = 7;
	alturaApp;
	constructor(
		private route: Router,
		private menusService: MenusService,
		public registerIcons: RegisterIconsService,
		public platformService: PlatformService,
		public ngZone: NgZone,
		private gAnalytics: GAnalyticsService,
		public filtroController: FiltroControllerService,
		private apiCotacoes: ApiCotacoesService,
		private buscaService: BuscaService,
		) {
		this.menusService.setButton(true);
		let icons = ['calculado', 'calculando', 'editando', 'home', 'car-hatchback', 'motorbike', 'truck', 'help-circle' , 'cards-heart', 'factory', 'plus', 'database-off', 'negocio_perdido', 'fechado_concluido', 'domain', 'file-search', 'database-eye-off', 'earth'];
		registerIcons.registerIcons(icons);

		this.retornoFiltro = new BehaviorSubject<any>('');
	}

	ngOnInit(): void {
		if (!this.isComponent) {
			this.generateSkeletonTable();
			this.setaAlturaApp();
			this.inscreverEmiters();
			this.intervalBusca();
			this.listaCotacoes();
			this.inicializaFiltros();
			this.gAnalytics.analyticsPageMonitor('Cotações', '/apice/cotacoes');
		}

	}

	ngOnChanges(changes: SimpleChanges){       
        if(changes.hasOwnProperty('dataBuscaGeral') && changes.dataBuscaGeral.currentValue){
			let count = 0;
			let interval2 = setInterval(()=> {
				count++;
				if(count > 50 || this.listaScrolling){
					this.listaCotacoes();
					clearInterval(interval2);
				}

			}, 100);
        }
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
	   this.setaAlturaApp();
	}

	inscreverEmiters() {
		this.subscriptions.add(
			this.menusService.onFiltragem.subscribe(ret => { this.filtrar(ret) })
		);
		this.subscriptions.add(
			this.buscaService.buscaEmitter.subscribe(event => {
				this.filtro(event);
			})
		);
	}

	setaAlturaApp() {
		try {
			let app = document.querySelector('.app');
			if (app) this.alturaApp = app.clientHeight;
		} catch (error) {
			return false;
		}
	}

	intervalBusca(){

		this.intervalUpdateList = setInterval(()=>{			
			this.counInterval++;			
			this.buscaParalela();

			if(this.counInterval == 5){
				this.timeInterval = (1000 * 60) * 5;
				this.changeInterval();
			}else if(this.counInterval == 10){
				this.timeInterval = (1000 * 60) * 10;
				this.changeInterval();
			}else if(this.counInterval == 15){
				this.timeInterval = (1000 * 60) * 30;
				this.changeInterval();
			}

		},this.timeInterval);

	}

	async changeInterval(){
		await clearInterval(this.intervalUpdateList);
		await this.intervalBusca();
	}

	atualizarListaCotacoes(){
		this.counInterval = 0;
		this.timeInterval = 1000 * 60;
		this.atualizarLista = false;
		this.copyList = [];
		this.novasCotacoes = null;
		this.listaScrolling.pullReloadingAnimation = 'show';
		this.changeInterval();
		this.clearFilter();
	}

	async buscaParalela(){
		try {
			if(!this.filtrou){
				let ret:any = await this.apiCotacoes.buscaNegociosPDocs(this.filtroBusca);
				if(ret?.data?.length){
					let listaNovo = ret.data.map( cotacao => new CotacoesPDocs().deserialize(cotacao) );
					let idsCopy = this.copyList.map( item => item.id );
					let idsNovo	= listaNovo.map( item => item.id);				
					let novasCotacoes = idsNovo.map((id, index)=>{					
						if(idsCopy.indexOf(id) < 0){
							return listaNovo[index];
						}
					}).filter(item => item != undefined);
					if(novasCotacoes.length){
						let count = novasCotacoes.length;
						this.novasCotacoes = count == 1 ? count + ' registro novo - Atualizar' : count >= 40 ? '40+ registros novos - Atualizar' : count + '  registros novos - Atualizar';
						this.atualizarLista = true;
					}
					// console.log('NOVAS COTAÇÕES', novasCotacoes);
				}	
			}		
		} catch (error) {
			console.log('error atualiza lista', error);
		}
	}

	async listaCotacoes(page?, next?, offset?, ramo?){	
		try {
			this.loading = true;
			let ret: any
			if (this.dataBuscaGeral?.cotacoes) {
				ret = this.dataBuscaGeral?.cotacoes;
			} else {
				ret = await this.apiCotacoes.buscaNegociosPDocs(
					this.filtroBusca, 
					page, 
					!ramo ? this.filtroController?.filtroRamoCotacoes : ramo,
					this.usuarioFiltrado ? this.usuarioFiltrado : '', 
					this.periodo.value,
					);
			}

			if(ret?.data){
				let lista = ret.data.map( cotacao => new CotacoesPDocs().deserialize(cotacao) );
				if(this.listaStatusNegocioFiltrados && this.listaStatusNegocioFiltrados.length) {
					let listaFiltrada = [];
					this.listaStatusNegocioFiltrados.forEach(status => {
						listaFiltrada = listaFiltrada.concat(lista.filter(cotacao => cotacao?.status == status));
					});
					lista = listaFiltrada;
				}
				

				this.listaScrolling.theEnd = lista.length ? false : true;
				if(this.listaScrolling.theEnd){ clearInterval(this.intervalUpdateList) }
				
				if(!next){
					// console.log('REGISTROS ANTIGOS', this.copyList);
					this.copyList = lista;
					this.lista = lista;
					// console.log('REGISTROS NOVOS', this.copyList);
				}else{
					this.ngZone.run(()=>{
						if(lista.length){
							this.lista = [...this.lista, ...lista];
							this.listaScrolling.offset.next(offset);
						}
						this.listaScrolling.loadingUpdateLista = false;	
					})
				}
				this.listaScrolling.calcHeight(this.lista.length, true);
				this.listaScrolling.viewPort.checkViewportSize();
				// console.log('lista cotacoes', this.lista);
			}
		} catch (error) {
			console.log('erro ao buscar lista de cotações', error);
			this.loading = false;
		} finally {
			this.ngZone.run(() => {
				this.listaScrolling.pullReloadingAnimation = 'hide'
			});
			this.loading = false;
		}

	}

	updateLista(ev){
		if (!this.isComponent) {
			this.listaCotacoes(ev.page, ev.next || undefined, ev.offset || undefined, this.ramo || 0);
		} else {
			this.listaScrolling.loadingUpdateLista = false;
			this.listaScrolling.pullReloadingAnimation = 'hide'
		}
	}

	open(url){
		//abrir modal/pagina
		// console.log('abrir cotação', url);
		if(!this.listaScrolling.movingList){
			this.route.navigateByUrl(url);
		}
	}

	novaCotacao() {

	}

	matMenuOpen(ev) {
		ev.stopPropagation();
		this.menuOpen = true
	}

	campoBusca:boolean = false;
	filtro(ev){
		this.campoBusca = true;
		this.filtroBusca = ev;
		this.listaCotacoes(null,null,null,this.ramo);
	}

	filtrou: boolean = false;
	filtrar(ev?) {
		this.filtrou = true;
		if (ev) {
		  this.usuarioFiltrado = ev.filtro.values.usuario;
		  this.listaStatusNegocioFiltrados = ev.filtro.values.listaStatusNegocio ? ev.filtro.values.listaStatusNegocio : [];
		}
		this.listaCotacoes(null,null,null,this.ramo);
		this.itensFiltrados = this.ramo != 1 ? 'filtradas' : 'todas';
	}

	filtroAuto:boolean = false;
  	filtroVida:boolean = false;
	filtroCond:boolean = false;
  	filtroResid:boolean = false;
  	filtroEmpre:boolean = false;
  	filtroTodos:boolean = false;
	filtrarBtn(ramo?) {
		this.filtroAuto = false;
		this.filtroVida = false;
		this.filtroResid = false;
		this.filtroEmpre = false;
		this.filtroTodos = false;
		this.filtroCond = false
		if (ramo === 31) {
		this.filtroAuto = true;
		} else if (ramo === 2) {
		this.filtroResid = true;
		} else if (ramo === 18) {
		this.filtroEmpre = true;
		} else if (ramo === 91) {
		this.filtroVida = true;
		} else if (ramo === 16) {
			this.filtroCond = true;
		} else if (ramo === '') {
		this.filtroTodos = true;
		}
		this.filtrou = true;
		this.ramo = ramo;
		this.filtroController.addFiltrosExtras('ramoCotacoes', this.ramo ? this.ramo : 0);
		this.listaCotacoes(null,null,null,this.ramo);
	}

	clearFilter(){
		this.ramo = 0;
		this.filtroController.limparFiltro('ramoCotacoes');
		this.listaCotacoes(null,null,null,this.ramo);
		this.itensFiltrados = 'todas';
	}

	inicializaFiltros(){
		if(this.filtroController?.filtroCotacoes){
			this.filtrou = true;
			this.usuarioFiltrado = this.filtroController.filtroCotacoes?.usuario;
			this.listaStatusNegocioFiltrados = this.filtroController.filtroCotacoes?.listaStatusNegocio ? this.filtroController.filtroCotacoes.listaStatusNegocio : [];
		}
		if(this.filtroController?.filtroRamoCotacoes) {
			this.ramo = this.filtroController.filtroRamoCotacoes;
			this.verificaIndexTabSelecionado();
		}
	}

	verificaIndexTabSelecionado() {
		let index = this.ramos.findIndex(ramo => ramo.id === this.ramo);
		if (index !== -1) this.ramoSelecionado.setValue(index);
	}
	
	generateSkeletonTable() {
		for (let y = 0; y < this.rows; y++) {
			let tmpData = [];
			for (let x = 0; x < this.columns; x++) {
				if(x === 0){
					tmpData.push(100);
				} else if(x === this.columns - 1){
					tmpData.push(50);
				} else{
					tmpData.push(this.random(50, 90));
				}
			}
			this.arraySkeleton.push(tmpData);
		}
	}

	random(min, max) {
		return Math.floor(Math.random() * (max - min) + min);
	}

	range(i: number) {
		return new Array(i);
	}

	ngOnDestroy() {
		this.menusService.setButton(false);
    	this.menusService.open = false;
		this.menusService.setMenuFilter({ open: false, page: '' })
		this.subscriptions.unsubscribe();
		clearInterval(this.intervalUpdateList);
	}
}
